module.exports = __webpack_public_path__ + "static/logo-4467ed3ebc6bba794bbc4586ced57795.png";